import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Fleet from "@/pages/Fleet";
import Destinations from "@/pages/Destinations";
import About from "@/pages/About";
import Contacts from "@/pages/Contacts";
import Booking from "@/pages/Booking";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <LanguageProvider>
      <div className="App dark">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/about" element={<About />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/privacy" element={<Privacy />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: { background: "#121214", border: "1px solid rgba(212,175,55,0.3)", color: "#fff" },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
